import React from 'react';
export function ExperimentIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.265 17.563L15 9.745V4a1 1 0 100-2H9a1 1 0 000 2v5.745l-4.264 7.818A3 3 0 007.369 22h9.262a3 3 0 002.634-4.437zm-8.387-7.084A1 1 0 0011 10V4h2v6a1 1 0 00.122.479L15.043 14H8.958l1.92-3.521zm6.613 9.032a.982.982 0 01-.86.489H7.369a1 1 0 01-.878-1.479L7.867 16h8.267l1.375 2.521a.986.986 0 01-.018.99z"
  }));
}